import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FormCard from '../components/FormCard';
import OTPInput from '../components/OTPInput';
import { authAPI } from '../services/api';

const VerifyOTP = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [phone, setPhone] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Get phone number from sessionStorage
    const storedPhone = sessionStorage.getItem('phoneNumber');
    if (!storedPhone) {
      // If no phone number, redirect back to login
      navigate('/login', { replace: true });
    } else {
      setPhone(storedPhone);
    }
  }, [navigate]);

  const handleVerifyOTP = async (otp) => {
    setLoading(true);
    setError('');

    try {
      const response = await authAPI.verifyOTP(phone, otp);

      if (response.success && response.token) {
        // Save token in sessionStorage
        sessionStorage.setItem('authToken', response.token);
        
        // Clear phone number from sessionStorage
        sessionStorage.removeItem('phoneNumber');

        // Navigate based on user status
        if (response.isNewUser) {
          navigate('/complete-signup');
        } else {
          navigate('/');
        }
      } else {
        setError(response.message || 'Invalid OTP. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setError('');
    try {
      const response = await authAPI.sendOTP(phone);
      if (response.success) {
        alert('OTP resent successfully!');
      }
    } catch (err) {
      setError('Failed to resend OTP. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-purple-600 to-purple-700 flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto scale-in">
        <div className="glass rounded-3xl shadow-2xl p-8 md:p-10">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mx-auto mb-4 float shadow-xl">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-2">Verify OTP</h3>
            <p className="text-gray-600">Enter the code sent to</p>
            <p className="text-primary font-semibold">{phone}</p>
          </div>

          {/* OTP Input */}
          <OTPInput
            length={6}
            onSubmit={handleVerifyOTP}
            loading={loading}
            error={error}
          />
          
          <div className="mt-6 text-center space-y-3">
            <button
              onClick={handleResendOTP}
              disabled={loading}
              className="text-primary hover:text-purple-700 font-semibold text-sm transition hover:underline disabled:opacity-50"
            >
              Didn't receive code? Resend OTP
            </button>

            <div className="pt-4 border-t border-gray-200">
              <button
                onClick={() => navigate('/login')}
                disabled={loading}
                className="text-gray-600 hover:text-gray-800 text-sm transition flex items-center justify-center mx-auto group disabled:opacity-50"
              >
                <svg className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Change Phone Number
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;

